import { render, staticRenderFns } from "./ReservationLink.vue?vue&type=template&id=4b7939e2&"
import script from "./ReservationLink.vue?vue&type=script&lang=js&"
export * from "./ReservationLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports